import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';

/*
 * FoF Badges utilise encore user.username() pour la route utilisateur :
 *
 *   /u/laurent/badges
 *
 * Flarum 2 utilise désormais user.slug() :
 *
 *   /u/1-laurent/badges
 *
 * On remplace donc l'item ajouté par FoF Badges après son initialisation.
 */
app.initializers.add('val-ui-user-badges-slug', () => {
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (!user || !app.forum.attribute('canViewUserBadges')) {
      return;
    }
    const badgeCount = user.attribute('badgeCount') || 0;
    items.add('badges', m(LinkButton, {
      href: app.route('user.badges', {
        username: user.slug()
      }),
      icon: "fas fa-award"
    }, app.translator.trans('fof-badges.forum.user.badges_tab'), badgeCount > 0 && m("span", {
      className: "Button-badge"
    }, badgeCount)), 80);
  });
}, -100);